import Home from "../page/home/Home";

export default function HomeHOC({ ...props }) {
  return (
    <>
      <Home {...props} />
    </>
  );
}
